import { render, staticRenderFns } from "./assignUser.vue?vue&type=template&id=fdabf234&"
import script from "./assignUser.vue?vue&type=script&lang=js&"
export * from "./assignUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports